import React, { useEffect, useState, useRef } from "react";
import Menu from "../../panel/Menu";
import {
  Box, Card, CardContent, Typography, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, TextField,
  Button, Stepper, Step, StepLabel, Paper, MenuItem, InputAdornment, Stack,
  Divider, CardHeader, Avatar, CircularProgress, Accordion, AccordionSummary, AccordionDetails,
  Switch, FormControlLabel, Menu as MuiMenu, Tooltip
} from "@mui/material";
import { ArrowBack, ArrowForward, Remove, Add, Delete, CameraAlt, UploadFile, WhatsApp, Phone } from "@mui/icons-material";
import LockOutlined from '@mui/icons-material/LockOutlined';
import LockOpenOutlined from '@mui/icons-material/LockOpenOutlined';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ArrowForwardIos, ArrowBackIosNew } from "@mui/icons-material";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { addDoc, collection, doc, getCountFromServer, getDoc, getDocs, onSnapshot, orderBy, query, serverTimestamp, Timestamp, updateDoc, deleteDoc, where } from 'firebase/firestore';
import { db, storage } from "../../firebase";
import { addDays, format, differenceInDays, startOfDay, parseISO, eachDayOfInterval } from "date-fns";
import { motion, AnimatePresence } from "framer-motion";
import moment from "moment";
import { getDownloadURL, ref, uploadString, uploadBytes } from 'firebase/storage';
import Swal from 'sweetalert2';
import Webcam from "react-webcam";
import { useNavigate } from "react-router-dom";

// Reduced sizes for calendar view
const PAGE_SIZE = 10;
const LEFT_COL_WIDTH = 140;
const COL_WIDTH = 100;
const ROW_HEIGHT = 48;

const steps = ['Room Details', 'Customer Details', 'Document Section', 'Payment & Checkout'];
const DOCUMENT_TYPES = [
  { label: 'Aadhaar Card', value: 'aadhaar' },
  { label: 'PAN Card', value: 'pan' },
  { label: 'Driving License', value: 'dl' },
  { label: 'Voter ID', value: 'voter_id' },
  { label: 'Passport', value: 'passport' },
  { label: 'Other', value: 'other' }
];

// Input sanitizers to block symbols on keystroke
const cleanName = (val) => val.replace(/[^a-zA-Z\s]/g, "");
const cleanCity = (val) => val.replace(/[^a-zA-Z\s]/g, "");
const cleanAlphanumeric = (val) => val.replace(/[^a-zA-Z0-9\s]/g, "");
const cleanDigits = (val) => val.replace(/\D/g, "");
const cleanGST = (val) => val.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();

const VALIDATION_RULES = {
  aadhaar: {
    pattern: /^\d{12}$/,
    clean: (val) => cleanDigits(val).slice(0, 12),
    message: 'Aadhaar must be exactly 12 digits.',
    placeholder: '12 Digit Aadhaar'
  },
  pan: {
    pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
    clean: (val) => val.replace(/[^a-zA-Z0-9]/g, "").toUpperCase().slice(0, 10),
    message: 'Invalid PAN (e.g. ABCDE1234F)',
    placeholder: 'ABCDE1234F'
  },
  dl: {
    pattern: /^[A-Z]{2}[0-9]{13,14}$/,
    clean: (val) => val.replace(/[^a-zA-Z0-9]/g, "").toUpperCase().slice(0, 16),
    message: 'Invalid DL (e.g. MH0120110001234)',
    placeholder: 'MH0120110001234'
  },
  voter_id: {
    pattern: /^[A-Z]{3}[0-9]{7}$/,
    clean: (val) => val.replace(/[^a-zA-Z0-9]/g, "").toUpperCase().slice(0, 10),
    message: 'Invalid Voter ID (e.g. ABC1234567)',
    placeholder: 'ABC1234567'
  },
  passport: {
    pattern: /^[A-PR-WYa-pr-wy][0-9]{7}$/,
    clean: (val) => val.replace(/[^a-zA-Z0-9]/g, "").toUpperCase().slice(0, 8),
    message: 'Invalid Passport format (e.g. A1234567)',
    placeholder: 'A1234567'
  },
  other: {
    pattern: /^[a-zA-Z0-9\s\-/]{3,20}$/,
    clean: (val) => val.replace(/[^a-zA-Z0-9\s\-/]/g, "").slice(0, 20),
    message: '3-20 alphanumeric characters only.',
    placeholder: 'Enter Document ID'
  }
};

const getFieldStyle = (value, isRequired = false, hasError = false) => ({
  "& .MuiInputLabel-root": {
    color: "#0284c7 !important",
    fontWeight: 600
  },
  "& .MuiOutlinedInput-root": {
    bgcolor: "#fff",
    "& fieldset": {
      borderColor: hasError
        ? "#ef4444"
        : (isRequired && value && String(value).trim().length > 0)
          ? "#15803d"
          : "#cbd5e1",
      borderWidth: (hasError || (isRequired && value && String(value).trim().length > 0)) ? "1.5px" : "1px"
    },
    "&:hover fieldset": {
      borderColor: hasError ? "#dc2626" : "#0284c7"
    },
    "&.Mui-focused fieldset": {
      borderColor: hasError ? "#dc2626" : "#0284c7"
    }
  }
});

export default function Reserveroom() {
  const Toast = Swal.mixin({
    toast: true, position: 'top-end', showConfirmButton: false, timer: 3000, timerProgressBar: true
  });
  const navigate = useNavigate();
  const auth = getAuth();
  const webcamRef = useRef(null);
  const fileInputRef = useRef(null);

  const [propertyId, setPropertyId] = useState(null);
  const [propertyName, setPropertyName] = useState("Our Hotel");
  const [roomTypes, setRoomTypes] = useState([]);
  const [roomNumbers, setRoomNumbers] = useState({});
  const [reservations, setReservations] = useState([]);
  const [reservationMap, setReservationMap] = useState({});
  const [paymodes, setpaymodes] = useState([]);
  const [dates, setDates] = useState([]);
  const [page, setPage] = useState(0);
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [bookingtypes, setbookingtypes] = useState([]);
  const [rooms, setrooms] = useState([]);
  const [plans, setplans] = useState([]);
  const [bookingrooms, setbookingrooms] = useState([]);
  const [activeStep, setActiveStep] = useState(0);

  // Form States
  const [checkindate, setcheckindate] = useState(moment().format('YYYY-MM-DD'));
  const [checkoutdate, setcheckoutdate] = useState(moment().add(1, 'days').format('YYYY-MM-DD'));
  const [noofdays, setnoofdays] = useState(1);
  const [checkintime, setcheckintime] = useState(moment().format('HH:mm A'));
  const [checkouttime, setcheckouttime] = useState('12:00 PM');
  const [adults, setadults] = useState(2);
  const [childs, setchilds] = useState(0);
  const [noofrooms, setnoofrooms] = useState(0);

  const [custname, setcustname] = useState("");
  const [mobile, setmobile] = useState("");
  const [whatsappMobile, setWhatsappMobile] = useState("");
  const [sameAsMobile, setSameAsMobile] = useState(true);
  const [email, setemail] = useState("");
  const [address, setaddress] = useState("");
  const [city, setcity] = useState("");
  const [state, setstate] = useState("Maharashtra");
  const [gender, setgender] = useState("Male");
  const [visitpurpose, setvisitpurpose] = useState("Personal");
  const [companydetails, setcompanydetails] = useState("");
  const [gstname, setgstname] = useState("");
  const [gstno, setgstno] = useState("");
  const [bookingsource, setbookingsource] = useState("Walk-in");
  const [bookingDate, setbookingDate] = useState(moment().format('YYYY-MM-DD'));

  const [documenttype, setdocumenttype] = useState("aadhaar");
  const [idno, setidno] = useState("");
  const [otherDocumentType, setOtherDocumentType] = useState('');
  const [error, setError] = useState('');
  const [adultsList, setAdultsList] = useState([]);

  // Photos & Upload
  const [activeCamera, setActiveCamera] = useState(null);
  const [activeDocUploadKey, setActiveDocUploadKey] = useState(null);
  const [photos, setPhotos] = useState({ visitor: '', idFront: '', idBack: '', couple: '' });
  const [photoUrls, setPhotoUrls] = useState({ visitorUrl: '', idFrontUrl: '', idBackUrl: '', coupleUrl: '' });
  const [uploadingState, setUploadingState] = useState({ visitor: false, idFront: false, idBack: false, couple: false });

  // Payment States
  const [paymode1, setpaymode1] = useState("");
  const [amount1, setamount1] = useState(0);
  const [paytime1, setpaytime1] = useState("");
  const [paymode2, setpaymode2] = useState("");
  const [amount2, setamount2] = useState(0);
  const [paytime2, setpaytime2] = useState("");
  const [rooamount, setrooamount] = useState(0);
  const [totalamount, settotalamount] = useState(0);
  const [advance, setadvance] = useState(0);
  const [remaining, setremaining] = useState(0);
  const [roundoff, setroundoff] = useState(0);
  const [note, setnote] = useState("");

  // Room Picker States
  const [rtypeid, setrtypeid] = useState("");
  const [roomid, setroomid] = useState("");
  const [planid, setplanid] = useState("");
  const [amount, setamount] = useState(0);
  const [discountupto, setdiscountupto] = useState(0);
  const [discount, setdiscount] = useState(0);
  const [discountError, setDiscountError] = useState("");
  const [roomrate, setroomrate] = useState(0);
  const [isAmountUnlocked, setIsAmountUnlocked] = useState(false);

  // Accordion & Filter Controls
  const [expanded, setExpanded] = useState(false);
  const [expandAll, setExpandAll] = useState(false);
  const [isBlocking, setIsBlocking] = useState(false);
  const [activeFilter, setActiveFilter] = useState("All");
  const [contextMenu, setContextMenu] = useState(null);

  useEffect(() => {
    const arr = [];
    for (let i = 0; i < 180; i++) arr.push(startOfDay(addDays(new Date(), i)));
    setDates(arr);
  }, []);

  useEffect(() => {
    return onAuthStateChanged(auth, async (user) => {
      if (!user) return;
      const snap = await getDocs(collection(db, "authroles"));
      snap.forEach((d) => { if (d.id === user.uid) setPropertyId(d.data().propertyId); });
    });
  }, [auth]);

  useEffect(() => {
    if (propertyId) {
      loadRooms();
      loadReservations();
      fetchData1();
      fetchPropertyName();
    }
  }, [propertyId]);

  useEffect(() => {
    if (roomTypes?.length > 0 && !expanded && !expandAll) {
      setExpanded(roomTypes[0].id);
    }
  }, [roomTypes, expandAll]);

  const fetchPropertyName = async () => {
    try {
      const docRef = doc(db, "properties", propertyId);
      const snap = await getDoc(docRef);
      if (snap.exists()) setPropertyName(snap.data().hotelname);
    } catch (e) {
      console.log("Error fetching property name:", e);
    }
  };

  const loadRooms = async () => {
    const roomsSnap = await getDocs(query(collection(db, "rooms"), where("propertyId", "==", propertyId)));
    setRoomTypes(roomsSnap.docs.map(d => ({ id: d.id, ...d.data() })));

    const infoSnap = await getDocs(query(collection(db, "roominfos"), where("propertyId", "==", propertyId)));
    const map = {};
    infoSnap.docs.forEach(d => {
      const { roomTypeId, roomNo } = d.data();
      if (!map[roomTypeId]) map[roomTypeId] = [];
      map[roomTypeId].push({ id: d.id, roomNo: roomNo, data: d.data() });
    });
    setRoomNumbers(map);
  };

  const buildReservationMap = (reservationsData) => {
    const map = {};
    reservationsData.forEach(r => {
      const checkin = new Date(r.checkindate);
      const checkout = new Date(r.checkoutdate);
      r.rooms?.forEach(room => {
        eachDayOfInterval({ start: checkin, end: new Date(checkout.getTime() - 86400000) }).forEach(day => {
          map[`${room.roomno}_${format(day, "yyyy-MM-dd")}`] = r;
        });
      });
    });
    return map;
  };

  const loadReservations = async () => {
    const q1 = query(collection(db, "reservations"), where("propertyId", "==", propertyId), where("status", "==", "Booked"));
    const q2 = query(collection(db, "reservations"), where("propertyId", "==", propertyId), where("status", "==", "Blocked"));

    const [snap1, snap2] = await Promise.all([getDocs(q1), getDocs(q2)]);
    const data = [...snap1.docs, ...snap2.docs].map(d => ({ id: d.id, ...d.data() }));

    setReservations(data);
    setReservationMap(buildReservationMap(data));
  };

  const fetchData1 = async () => {
    try {
      onSnapshot(query(collection(db, 'paymentmodes'), where('propertyId', '==', propertyId), orderBy('createdAt', 'asc')), (snap) => {
        if (snap.docs.length > 0) {
          setpaymode1(snap.docs[0].id);
          setpaymode2(snap.docs[0].id);
        }
        setpaymodes(snap.docs.map(doc => ({ id: doc.id, data: doc.data() })));
      });
      onSnapshot(query(collection(db, 'bookingtypes'), where('propertyId', '==', propertyId), orderBy('createdAt', 'asc')), (snap) => {
        setbookingtypes(snap.docs.map(doc => ({ id: doc.id, data: doc.data() })));
      });
    } catch (error) {
      console.log(error);
    }
  };

  const visibleDates = Array.from({ length: PAGE_SIZE }, (_, i) => addDays(new Date(), page * PAGE_SIZE + i));
  const getReservationForCell = (roomNo, date) => reservationMap[`${roomNo}_${format(date, "yyyy-MM-dd")}`] || null;

  // STEP VALIDATION
  const handleNext = async () => {
    if (activeStep === 0) {
      if (bookingrooms.length === 0) return Toast.fire({ icon: "error", title: "Please add at least one room." });
      if (!checkindate || !checkoutdate) return Toast.fire({ icon: "error", title: "Please select valid dates." });
    }
    if (activeStep === 1) {
      if (!custname.trim() || !mobile.trim() || !address.trim() || !city.trim()) {
        return Toast.fire({ icon: "error", title: "Please fill all required customer fields." });
      }
      if (mobile.length < 10) return Toast.fire({ icon: "error", title: "Valid 10-digit mobile number required." });
      if (documenttype && idno) {
        const rule = VALIDATION_RULES[documenttype];
        if (rule && !rule.pattern.test(idno)) {
          return Toast.fire({ icon: "error", title: rule.message });
        }
      }
      if (error) return Toast.fire({ icon: "error", title: "Please fix document ID validation errors." });

      for (let i = 0; i < adultsList.length; i++) {
        const g = adultsList[i];
        if (g.docType && g.idNo) {
          const r = VALIDATION_RULES[g.docType];
          if (r && !r.pattern.test(g.idNo)) {
            return Toast.fire({ icon: "error", title: `Guest #${i + 1}: ${r.message}` });
          }
        }
      }

      try {
        await addDoc(collection(db, "reservation_leads"), {
          custname, mobile, whatsappMobile: sameAsMobile ? mobile : whatsappMobile,
          email, address, city, state, propertyId, step: 2, createdAt: serverTimestamp()
        });
      } catch (e) {
        console.warn("Could not save lead", e);
      }
    }
    setActiveStep((prev) => prev + 1);
  };

  const handleBack = () => setActiveStep((prev) => prev - 1);

  const handleDateChange = (date1, date2) => {
    if (date1 && date2) {
      const diffInDays = moment(date2).diff(moment(date1), 'days');
      const finalDays = diffInDays <= 0 ? 1 : diffInDays;
      setnoofdays(finalDays);
      calFinalTotal(finalDays, rooamount);
    }
  };

  const calFinalTotal = (days, roomamountxx) => {
    let total = parseFloat(days) * parseFloat(roomamountxx || 0);
    let roff = total.toFixed(2) - total.toFixed(0);
    setroundoff(roff.toFixed(2));
    settotalamount(total.toFixed(0));
    setremaining((total - parseFloat(advance || 0)).toFixed(0));
  };

  const handleroomtypeChange = (value) => {
    setrtypeid(value); setamount(0); setroomrate(0); setdiscount(0); setdiscountupto(0); setroomid("");
    onSnapshot(query(collection(db, 'roominfos'), where('roomTypeId', '==', value)), (snap) => setrooms(snap.docs.map(doc => ({ id: doc.id, data: doc.data() }))));
    onSnapshot(query(collection(db, 'roomrates'), where('roomId', '==', value)), (snap) => setplans(snap.docs.map(doc => ({ id: doc.id, data: doc.data() }))));
  };

  const getAvailableRooms = () => {
    if (!checkindate || !checkoutdate) return [];
    try {
      const inDate = parseISO(checkindate);
      const outDate = parseISO(checkoutdate);

      let daysToCheck = [];
      if (inDate < outDate) {
        daysToCheck = eachDayOfInterval({
          start: inDate,
          end: new Date(outDate.getTime() - 86400000)
        });
      } else {
        daysToCheck = [inDate];
      }

      return rooms.filter(room => {
        const roomNo = room.data.roomNo;
        const isBookedInDb = daysToCheck.some(day => !!reservationMap[`${roomNo}_${format(day, "yyyy-MM-dd")}`]);
        const isAlreadyAdded = bookingrooms.some(b => b.roomid === room.id);
        return !isBookedInDb && !isAlreadyAdded;
      });
    } catch (error) {
      return rooms;
    }
  };

  const availableRooms = getAvailableRooms();

  const handleplanChange = async (planDocId) => {
    setplanid(planDocId); setDiscountError("");
    try {
      const snap = await getDoc(doc(db, "roomrates", planDocId));
      if (snap.exists()) {
        const data = snap.data();
        setamount(Number(data.rate || 0).toFixed(2));
        setroomrate(Number(data.rate || 0).toFixed(2));
        setdiscountupto(data.discount || 0);
      }
    } catch (e) { console.error(e); }
  };

  const toggleAmountLock = async () => {
    const nextState = !isAmountUnlocked;
    setIsAmountUnlocked(nextState);
    if (nextState && propertyId) {
      try {
        await addDoc(collection(db, "activity_logs"), {
          propertyId,
          uid: auth.currentUser?.uid || "unknown",
          action: "UNLOCK_ROOM_RATE",
          roomTypeId: rtypeid,
          originalAmount: amount,
          timestamp: serverTimestamp()
        });
      } catch (err) {
        console.error("Failed to log lock action", err);
      }
    }
  };

  const isRoomReadyToAdd = isBlocking
    ? Boolean(roomid && rtypeid)
    : Boolean(roomid && rtypeid && planid && Number(amount) > 0 && Number(roomrate) > 0);

  const handleRoomArray = () => {
    if (isBlocking) {
      if (!roomid || !rtypeid) return Toast.fire({ icon: "error", title: "Room mapping fields are required" });
    } else {
      if (!roomid || !rtypeid || !planid || !amount || !roomrate) return Toast.fire({ icon: "error", title: "All room fields are required" });
    }

    const matchedRoom = rooms.find(r => r.id === roomid);
    const matchedPlan = plans.find(p => p.id === planid);
    const newItem = {
      roomid, roomno: matchedRoom?.data?.roomNo || "", rtypeid, roomtypename: matchedRoom?.data?.roomTypeName || "",
      planid: planid || "", planname: matchedPlan?.data?.planName || "", amount: Number(amount || 0).toFixed(2),
      discount: Number(discount || 0), roomrate: Number(roomrate || 0).toFixed(2),
    };
    const updatedRooms = [...bookingrooms, newItem];
    setbookingrooms(updatedRooms);
    setnoofrooms(updatedRooms.length);
    const totalRoomAmount = updatedRooms.reduce((sum, r) => sum + Number(r.roomrate || 0), 0);
    setrooamount(totalRoomAmount.toFixed(2));
    calFinalTotal(noofdays, totalRoomAmount);
    setrtypeid(""); setroomid(""); setplanid(""); setamount(""); setdiscount(""); setdiscountupto(0); setroomrate("");
  };

  const removeItem = (itemToRemove) => {
    const updatedItems = bookingrooms.filter((item) => item !== itemToRemove);
    setbookingrooms(updatedItems);
    setnoofrooms(updatedItems.length);
    const totalRoomAmount = updatedItems.reduce((sum, r) => sum + Number(r.roomrate || 0), 0);
    setrooamount(totalRoomAmount.toFixed(2));
    calFinalTotal(noofdays, totalRoomAmount);
  };

  const handleamount1 = (e) => {
    let val = parseFloat(e.target.value || 0);
    let adv = val + parseFloat(amount2 || 0);
    if (adv > totalamount) return Toast.fire({ icon: "error", title: `Max advance: ${totalamount}` });
    setamount1(val); setadvance(adv); setremaining((totalamount - adv).toFixed(2));
  };
  const handleamount2 = (e) => {
    let val = parseFloat(e.target.value || 0);
    let adv = parseFloat(amount1 || 0) + val;
    if (adv > totalamount) return Toast.fire({ icon: "error", title: `Max advance: ${totalamount}` });
    setamount2(val); setadvance(adv); setremaining((totalamount - adv).toFixed(2));
  };

  const handleCapture = () => {
    if (!webcamRef.current) return;
    const imageSrc = webcamRef.current.getScreenshot();
    setPhotos(p => ({ ...p, [activeCamera]: imageSrc }));
    setActiveCamera(null);
  };

  const handleFileChange = async (e, key) => {
    const file = e.target.files[0];
    if (!file) return;
    try {
      setUploadingState(s => ({ ...s, [key]: true }));
      const storageRef = ref(storage, `bookings/${Date.now()}_${key}_${file.name}`);
      await uploadBytes(storageRef, file);
      const url = await getDownloadURL(storageRef);
      setPhotoUrls(u => ({ ...u, [`${key}Url`]: url }));
      setPhotos(p => ({ ...p, [key]: url }));
      Toast.fire({ icon: "success", title: `${key} uploaded successfully` });
    } catch (err) {
      console.error(err);
      Toast.fire({ icon: "error", title: "Upload failed" });
    } finally {
      setUploadingState(s => ({ ...s, [key]: false }));
    }
  };

  const uploadPhoto = async (type) => {
    if (!photos[type]) return;
    try {
      setUploadingState(s => ({ ...s, [type]: true }));
      const storageRef = ref(storage, `bookings/${Date.now()}_${type}.jpg`);
      await uploadString(storageRef, photos[type], 'data_url');
      const url = await getDownloadURL(storageRef);
      setPhotoUrls(u => ({ ...u, [`${type}Url`]: url }));
      Toast.fire({ icon: "success", title: `${type} uploaded` });
    } catch (err) {
      Toast.fire({ icon: "error", title: "Upload failed" });
    } finally {
      setUploadingState(s => ({ ...s, [type]: false }));
    }
  };

  const sendWhatsAppMessage = async (customerName, propName, roomStr, totAmount, inDate, outDate, mob) => {
    const targetMobile = sameAsMobile ? mob : (whatsappMobile || mob);
    const wabaid = "1264091500117064";
    const accesstoken = "EAAcHt0w4sPkBSKT54p1Lpz2Jly0a5vhY1ks0UYJvVXygq23kb1TdHWR6bUzOfADscZBmm9eQk6CDYis6MyY3cLlYJZBvFcrgEjq0P4aHBjT9ZAMrCK3hufE5oOFKtgHFfq3BnLcR5FCqugCJ4L6WcSpyAwoKQpz0KrLGdF3iOJt9DHOZATbI2lHnym5n8umjGQZDZD";
    const payload = {
      messaging_product: 'whatsapp',
      recipient_type: 'individual',
      to: '91' + targetMobile,
      type: 'template',
      template: {
        name: 'checkin_confirmation',
        language: { code: 'en' },
        components: [{
          type: 'body',
          parameters: [
            { type: 'text', text: customerName || "Guest" },
            { type: 'text', text: propName },
            { type: 'text', text: roomStr || "N/A" },
            { type: 'text', text: String(totAmount) },
            { type: 'text', text: inDate },
            { type: 'text', text: outDate },
          ],
        }],
      },
    };
    try {
      const response = await fetch(`https://graph.facebook.com/v20.0/${wabaid}/messages`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accesstoken}` },
        body: JSON.stringify(payload),
      });
      if (response.ok) {
        await addDoc(collection(db, 'whatsapphistory'), {
          custname: customerName, type: 'Checkin', mobile: targetMobile, createdAt: Timestamp.now(), propertyId
        });
      }
    } catch (error) { console.error('Failed to send WhatsApp', error); }
  };

  const syncInventoryToOTA = async (bookedRoomsList) => {
    try {
      const configSnap = await getDoc(doc(db, "channel_manager", propertyId));
      if (!configSnap.exists()) return;
      const { hotelCode, authCode } = configSnap.data();

      const dataToSync = [];
      const affectedTypes = [...new Set(bookedRoomsList.map(r => r.rtypeid))];

      for (const typeId of affectedTypes) {
        const roomTypeInfo = roomTypes.find(rt => rt.id === typeId);
        if (!roomTypeInfo || !roomTypeInfo.cmId) continue;

        const cmId = roomTypeInfo.cmId;
        const roomTypeName = roomTypeInfo.roomTypeName || "Unknown";
        const totalRoomsForType = roomNumbers[typeId] || [];
        const maxCmAllowed = roomTypeInfo.maxCmRoomCount !== undefined ? Number(roomTypeInfo.maxCmRoomCount) : totalRoomsForType.length;

        for (let day = 0; day < noofdays; day++) {
          const d = moment(checkindate).add(day, "days").format("YYYY-MM-DD");

          let bookedCount = 0;
          totalRoomsForType.forEach(physicalRoom => {
            if (reservationMap[`${physicalRoom.roomNo}_${d}`]) {
              bookedCount++;
            }
          });

          const newlyBookedCount = bookedRoomsList.filter(r => r.rtypeid === typeId).length;
          let available = maxCmAllowed - (bookedCount + newlyBookedCount);
          if (available < 0) available = 0;

          dataToSync.push({
            roomId: String(cmId),
            roomName: roomTypeName,
            startDate: d,
            endDate: d,
            availability: String(available)
          });
        }
      }

      if (dataToSync.length === 0) return;

      const payload = {
        Authentication: { HotelCode: hotelCode, AuthCode: authCode },
        Inventories: {
          Inventory: dataToSync.map(item => ({
            RoomId: item.roomId,
            FromDate: item.startDate,
            ToDate: item.endDate,
            AvailableRoomCount: item.availability
          }))
        }
      };

      const response = await fetch('https://navajowhite-wren-495848.hostingersite.com/api/inventory-update', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const result = await response.json();
      if (result.APIResponse?.IsSuccess) {
        const promises = dataToSync.map(item => addDoc(collection(db, "ota_inventory_updates"), {
          propertyId,
          roomId: item.roomId,
          roomName: item.roomName,
          availability: item.availability,
          startDate: item.startDate,
          endDate: item.endDate,
          status: "Synced",
          syncedAt: new Date().toISOString(),
          createdAt: serverTimestamp()
        }));
        await Promise.all(promises);
      }
    } catch (error) {
      console.error("Failed to sync inventory to OTA", error);
    }
  };

  const syncSpecificInventoryToOTA = async (affectedTypes, checkIn, days) => {
    try {
      const configSnap = await getDoc(doc(db, "channel_manager", propertyId));
      if (!configSnap.exists()) return;
      const { hotelCode, authCode } = configSnap.data();

      const dataToSync = [];
      const q1 = query(collection(db, "reservations"), where("propertyId", "==", propertyId), where("status", "==", "Booked"));
      const q2 = query(collection(db, "reservations"), where("propertyId", "==", propertyId), where("status", "==", "Blocked"));
      const [snap1, snap2] = await Promise.all([getDocs(q1), getDocs(q2)]);
      const freshReservations = [...snap1.docs, ...snap2.docs].map(d => ({ id: d.id, ...d.data() }));
      const freshMap = buildReservationMap(freshReservations);

      for (const typeId of affectedTypes) {
        const roomTypeInfo = roomTypes.find(rt => rt.id === typeId);
        if (!roomTypeInfo || !roomTypeInfo.cmId) continue;

        const cmId = roomTypeInfo.cmId;
        const roomTypeName = roomTypeInfo.roomTypeName || "Unknown";
        const totalRoomsForType = roomNumbers[typeId] || [];
        const maxCmAllowed = roomTypeInfo.maxCmRoomCount !== undefined ? Number(roomTypeInfo.maxCmRoomCount) : totalRoomsForType.length;

        for (let day = 0; day < days; day++) {
          const d = moment(checkIn).add(day, "days").format("YYYY-MM-DD");

          let bookedCount = 0;
          totalRoomsForType.forEach(physicalRoom => {
            if (freshMap[`${physicalRoom.roomNo}_${d}`]) {
              bookedCount++;
            }
          });

          let available = maxCmAllowed - bookedCount;
          if (available < 0) available = 0;

          dataToSync.push({
            roomId: String(cmId),
            roomName: roomTypeName,
            startDate: d,
            endDate: d,
            availability: String(available)
          });
        }
      }

      if (dataToSync.length === 0) return;

      const payload = {
        Authentication: { HotelCode: hotelCode, AuthCode: authCode },
        Inventories: {
          Inventory: dataToSync.map(item => ({
            RoomId: item.roomId,
            FromDate: item.startDate,
            ToDate: item.endDate,
            AvailableRoomCount: item.availability
          }))
        }
      };

      const response = await fetch('https://navajowhite-wren-495848.hostingersite.com/api/inventory-update', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const result = await response.json();
      if (result.APIResponse?.IsSuccess) {
        const promises = dataToSync.map(item => addDoc(collection(db, "ota_inventory_updates"), {
          propertyId,
          roomId: item.roomId,
          roomName: item.roomName,
          availability: item.availability,
          startDate: item.startDate,
          endDate: item.endDate,
          status: "Synced",
          syncedAt: new Date().toISOString(),
          createdAt: serverTimestamp()
        }));
        await Promise.all(promises);
      }
    } catch (error) {
      console.error("Failed to sync specific inventory to OTA", error);
    }
  };

  const safe = (obj) => Object.fromEntries(Object.entries(obj).filter(([_, v]) => v !== undefined));

  const pushToPipeline = async (pipelineStatus) => {
    try {
      setIsLoading(true);
      const customerData = {
        custname, mobile, whatsappMobile: sameAsMobile ? mobile : whatsappMobile,
        email, address, city, state, gender, propertyId,
        uid: auth.currentUser?.uid, createdAt: Timestamp.now(),
      };
      await addDoc(collection(db, "pipeline_bookings"), {
        customer: customerData,
        rooms: bookingrooms,
        checkindate, checkoutdate, noofdays,
        pipelineStatus,
        totalamount: Number(totalamount),
        propertyId,
        uid: auth.currentUser?.uid,
        createdAt: Timestamp.now()
      });
      Toast.fire({ icon: "success", title: `Successfully pushed to ${pipelineStatus}` });
      setOpen(false);
    } catch (e) {
      console.error(e);
      Toast.fire({ icon: "error", title: "Failed to push booking", text: e.message });
    } finally {
      setIsLoading(false);
    }
  };

  const checkoutReservation = async () => {
    try {
      setIsLoading(true);
      const customerData = {
        custname, mobile, whatsappMobile: sameAsMobile ? mobile : whatsappMobile,
        email, address, city, state, gender, gstname, gstno, documenttype, otherDocumentType, idno,
        propertyId, uid: auth.currentUser?.uid, createdAt: Timestamp.now(),
      };
      const customerRef = await addDoc(collection(db, "customers"), customerData);

      const q = query(collection(db, "reservations"), where("propertyId", "==", propertyId));
      const bookingCountSnap = await getCountFromServer(q);
      const invoiceNo = bookingCountSnap.data().count + 1;

      const bookingPayload = safe({
        customerId: customerRef.id, invoiceno: invoiceNo, customers: customerData, rooms: bookingrooms, services: [],
        checkindate, checkoutdate, noofdays, checkintime, checkouttime, adults, childs, noofrooms: bookingrooms.length,
        visitpurpose, bookingsource,
        visitorPhotoUrl: photoUrls.visitorUrl, idFrontUrl: photoUrls.idFrontUrl,
        idBackUrl: photoUrls.idBackUrl, couplePhotoUrl: photoUrls.coupleUrl,
        rooamount: Number(rooamount), roundoff: Number(roundoff), totalamount: Number(totalamount),
        advance: Number(advance), remaining: Number(remaining), note, bookingDate, type: "GST", status: "Booked",
        approval1: "No", approval2: "No", approval3: "No", approval4: "No", damageamount: 0,
        propertyId, uid: auth.currentUser?.uid, additionalAdults: adultsList, createdAt: Timestamp.now(),
      });
      const bookingRef = await addDoc(collection(db, "reservations"), bookingPayload);

      for (let day = 0; day < noofdays; day++) {
        const inDate = moment(checkindate).add(day, "days").format("YYYY-MM-DD");
        const outDate = moment(checkindate).add(day + 1, "days").format("YYYY-MM-DD");
        for (const room of bookingrooms) {
          await addDoc(collection(db, "checkindetails"), safe({
            bookingid: bookingRef.id, customerId: customerRef.id, checkindate: inDate, checkoutdate: outDate,
            propertyId, roomid: room.roomid, roomtypeid: room.rtypeid, planid: room.planid, roomname: room.roomno,
            planname: room.planname, roomtype: room.roomtypename, status: "Booked", uid: auth.currentUser?.uid, createdAt: Timestamp.now(),
          }));
        }
      }

      if (Number(advance) > 0) {
        for (let i = 0; i < noofdays; i++) {
          await addDoc(collection(db, "payhistory"), {
            bookingid: bookingRef.id, customerId: customerRef.id, paymode1, amount1: Number(amount1) / noofdays, paytime1,
            paymode2, amount2: Number(amount2 || 0) / noofdays, paytime2, type: "Booking", paymenttype: "B", status: "Working",
            propertyId, uid: auth.currentUser?.uid, note, createdAt: Timestamp.fromDate(new Date(new Date().setDate(new Date().getDate() + i))),
          });
        }
      }

      for (const room of bookingrooms) {
        await updateDoc(doc(db, "roominfos", room.roomid), { status: "Booked" });
      }

      await syncInventoryToOTA(bookingrooms);

      const roomStr = bookingrooms.map(r => r.roomno).join(', ');
      const inTimeStr = `${moment(checkindate).format('DD-MM-YYYY')} ${checkintime}`;
      const outTimeStr = `${moment(checkoutdate).format('DD-MM-YYYY')} ${checkouttime}`;
      await sendWhatsAppMessage(custname, propertyName, roomStr, totalamount, inTimeStr, outTimeStr, mobile);

      Toast.fire({ icon: "success", title: "Reservation successfully completed" });
      setTimeout(() => window.location.reload(), 1500);
    } catch (error) {
      console.error(error);
      Toast.fire({ icon: "error", title: "Reservation failed", text: error.message });
    } finally {
      setIsLoading(false);
      setOpen(false);
    }
  };

  const blockReservation = async () => {
    if (bookingrooms.length === 0) return Toast.fire({ icon: "error", title: "Please add at least one room to block." });
    try {
      setIsLoading(true);

      const q = query(collection(db, "reservations"), where("propertyId", "==", propertyId));
      const bookingCountSnap = await getCountFromServer(q);
      const invoiceNo = bookingCountSnap.data().count + 1;

      const bookingPayload = safe({
        invoiceno: invoiceNo, rooms: bookingrooms, checkindate, checkoutdate, noofdays,
        noofrooms: bookingrooms.length, note: note || "Blocked for Maintenance", bookingDate,
        type: "Block", status: "Blocked", propertyId, uid: auth.currentUser?.uid, createdAt: Timestamp.now(),
      });
      await addDoc(collection(db, "reservations"), bookingPayload);

      for (const room of bookingrooms) {
        await updateDoc(doc(db, "roominfos", room.roomid), { status: "Blocked" });
      }

      await syncInventoryToOTA(bookingrooms);

      Toast.fire({ icon: "success", title: "Room blocked successfully" });
      setTimeout(() => window.location.reload(), 1500);
    } catch (error) {
      console.error(error);
      Toast.fire({ icon: "error", title: "Block operation failed", text: error.message });
    } finally {
      setIsLoading(false);
      setOpen(false);
    }
  };

  const unblockReservation = async (resData) => {
    try {
      setIsLoading(true);
      await deleteDoc(doc(db, "reservations", resData.id));

      if (resData.rooms && resData.rooms.length > 0) {
        for (const room of resData.rooms) {
          await updateDoc(doc(db, "roominfos", room.roomid), { status: "Available" });
        }
      }

      const affectedTypes = [...new Set(resData.rooms.map(r => r.rtypeid))];
      await syncSpecificInventoryToOTA(affectedTypes, resData.checkindate, resData.noofdays);

      Toast.fire({ icon: "success", title: "Block removed successfully" });
      setTimeout(() => window.location.reload(), 1500);
    } catch (error) {
      console.error(error);
      Toast.fire({ icon: "error", title: "Failed to remove block", text: error.message });
    } finally {
      setIsLoading(false);
    }
  };

  const getRoomTypeData = (rt) => {
    handleroomtypeChange(rt.roomType.id);
    setroomid(rt.roomInfoId);
  };

  const handleCellRightClick = (e, rt, room, d) => {
    e.preventDefault();
    setContextMenu({
      mouseX: e.clientX + 2,
      mouseY: e.clientY - 6,
      roomType: rt,
      room,
      date: d
    });
  };

  const handleContextMenuSelect = (chosenType) => {
    if (!contextMenu) return;
    const { roomType, room, date } = contextMenu;
    setSelected({ roomType, roomNumber: room.roomNo, roomInfoId: room.id });
    getRoomTypeData({ roomType, roomNumber: room.roomNo, roomInfoId: room.id });
    setcheckindate(format(date, "yyyy-MM-dd"));
    setcheckoutdate(format(addDays(date, 1), "yyyy-MM-dd"));

    if (chosenType === "BlockRoom") {
      setIsBlocking(true);
    } else {
      setIsBlocking(false);
      setbookingsource(chosenType);
    }
    setContextMenu(null);
    setOpen(true);
  };

  const getBookingSourceStyles = (source) => {
    const normSource = (source || "").toLowerCase().trim();
    if (normSource.includes("booking.com") || normSource.includes("ota") || normSource.includes("expedia")) {
      return { bg: "rgba(14, 165, 233, 0.12)", border: "#0ea5e9", text: "#0369a1" };
    }
    if (
      normSource.includes("mmt") || normSource.includes("makemytrip") ||
      normSource.includes("makey my trip") || normSource.includes("goibibo") ||
      normSource.includes("goibibio") || normSource.includes("agoda") || normSource.includes("agpda")
    ) {
      return { bg: "rgba(236, 72, 153, 0.12)", border: "#ec4899", text: "#be185d" };
    }
    if (normSource.includes("website") || normSource.includes("direct")) {
      return { bg: "rgba(99, 102, 241, 0.12)", border: "#6366f1", text: "#4338ca" };
    }
    if (normSource.includes("walk")) {
      return { bg: "rgba(34, 197, 94, 0.12)", border: "#22c55e", text: "#166534" };
    }
    if (normSource.includes("call") || normSource.includes("phone")) {
      return { bg: "rgba(168, 85, 247, 0.12)", border: "#a855f7", text: "#7e22ce" };
    }
    if (normSource.includes("agent") || normSource.includes("reference") || normSource.includes("b2b")) {
      return { bg: "rgba(45, 212, 191, 0.15)", border: "#14b8a6", text: "#115e59" };
    }
    return { bg: "rgba(148, 163, 184, 0.12)", border: "#94a3b8", text: "#475569" };
  };

  const InfoRow = ({ label, value, highlight }) => (
    <Box display="flex" justifyContent="space-between" mb={0.5}>
      <Typography variant="body2" color="text.secondary">{label}</Typography>
      <Typography variant="body2" fontWeight={highlight ? 700 : 500} color={highlight ? "primary" : "text.primary"}>{value}</Typography>
    </Box>
  );

  return (
    <Box display="flex" minHeight="100vh" bgcolor="#F0F2F5">
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={(e) => activeDocUploadKey && handleFileChange(e, activeDocUploadKey)}
      />

      <Box flex={1} p={2} component={motion.div} initial={{ opacity: 0 }} animate={{ opacity: 1 }}>

        {/* HEADER */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1.5}>
          <Box display="flex" alignItems="center" gap={2}>
            <Typography variant="h5" fontWeight={800} color="primary">RESERVATION</Typography>
            <Tooltip title="Support Call">
              <IconButton size="small" color="primary" sx={{ bgcolor: 'rgba(2, 132, 199, 0.1)' }}>
                <Phone fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
          <Box display="flex" alignItems="center" gap={2}>
            <FormControlLabel
              control={
                <Switch
                  checked={expandAll}
                  onChange={(e) => setExpandAll(e.target.checked)}
                  color="primary"
                />
              }
              label={
                <Typography variant="body2" fontWeight={600} color="text.secondary">
                  Expand All Rooms
                </Typography>
              }
            />
            <Paper elevation={0} sx={{ borderRadius: 3, display: 'flex', gap: 1, border: '1px solid #cbd5e1' }}>
              <IconButton onClick={() => setPage(page - 1)}><ArrowBack /></IconButton>
              <Box display="flex" alignItems="center" px={2} fontWeight={600}>
                {format(visibleDates[0] || new Date(), "dd MMM")} - {format(visibleDates[PAGE_SIZE - 1] || new Date(), "dd MMM yyyy")}
              </Box>
              <IconButton onClick={() => setPage(page + 1)}><ArrowForward /></IconButton>
            </Paper>
          </Box>
        </Box>

        {/* STATUS FILTERS */}
        <Box display="flex" gap={1.5} flexWrap="wrap" mb={2}>
          {["All", "Direct", "OTA", "MMT", "Walk-in", "Call", "Blocked"].map((filterKey) => (
            <Button
              key={filterKey}
              size="small"
              onClick={() => setActiveFilter(activeFilter === filterKey && filterKey !== "All" ? "All" : filterKey)}
              variant={activeFilter === filterKey ? "contained" : "outlined"}
              sx={{
                borderRadius: 6,
                textTransform: 'none',
                boxShadow: 'none',
                bgcolor: activeFilter === filterKey ? 'primary.main' : '#fff'
              }}
            >
              {filterKey === "All" ? "All Bookings" : filterKey}
            </Button>
          ))}
        </Box>

        {/* TIMELINE */}
        <Card sx={{ borderRadius: "16px", boxShadow: "0 10px 32px rgba(0,0,0,0.04)", border: "1px solid #e2e8f0" }}>
          <Box sx={{ overflowX: "auto", position: "relative" }}>
            <Box display="flex" sx={{ borderBottom: "1px solid #cbd5e1", minWidth: "max-content", bgcolor: "#fff" }}>
              <Box sx={{ minWidth: LEFT_COL_WIDTH, p: 2, borderRight: "1px solid #cbd5e1", fontWeight: 700, fontSize: "0.75rem", position: "sticky", left: 0, zIndex: 3, bgcolor: "#fff" }}>ROOM DETAILS</Box>
              {visibleDates.map((d) => (
                <Box key={d.toString()} width={COL_WIDTH} sx={{ p: "12px 8px", textAlign: "center", borderRight: "1px solid #cbd5e1", bgcolor: [0, 6].includes(d.getDay()) ? "#f8fafc" : "#fff" }}>
                  <Typography variant="caption" fontWeight={600} sx={{ color: [0, 6].includes(d.getDay()) ? "#6366f1" : "#94a3b8", display: "block", fontSize: "10px" }}>{format(d, "EEE").toUpperCase()}</Typography>
                  <Typography variant="h6" fontWeight={700} sx={{ color: [0, 6].includes(d.getDay()) ? "#4338ca" : "#1e293b", mt: 0.2, fontSize: "1.05rem" }}>{format(d, "dd")}</Typography>
                </Box>
              ))}
            </Box>
            {roomTypes.map((rt) => (
              <Accordion
                key={rt.id}
                expanded={expandAll ? true : expanded === rt.id}
                onChange={() => {
                  if (!expandAll) {
                    setExpanded(expanded === rt.id ? false : rt.id);
                  }
                }}
                disableGutters
                elevation={0}
                sx={{ borderBottom: "1px solid #cbd5e1", "&:before": { display: "none" } }}
              >
                <AccordionSummary sx={{ bgcolor: "#f8fafc", height: "44px", borderBottom: (expandAll || expanded === rt.id) ? "1px solid #cbd5e1" : "none" }} expandIcon={!expandAll && <ExpandMoreIcon sx={{ fontSize: 18 }} />}>
                  <Typography fontWeight={700} sx={{ fontSize: "0.85rem" }}>{rt.roomTypeName}</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ p: 0, minWidth: "max-content" }}>
                  {(roomNumbers[rt.id] || []).map((room) => (
                    <Box key={room.id} display="flex" sx={{ borderBottom: "1px solid #cbd5e1", position: "relative" }}>
                      <Box sx={{ minWidth: LEFT_COL_WIDTH, p: "10px 16px", borderRight: "1px solid #cbd5e1", bgcolor: "#fff", zIndex: 2, position: "sticky", left: 0 }}>
                        <Typography variant="subtitle2" fontWeight={700}>Room {room.roomNo}</Typography>
                        <Typography variant="caption" sx={{ color: "#94a3b8", fontSize: "10px" }}>{rt.roomTypeName}</Typography>
                      </Box>
                      {visibleDates.map((d) => {
                        const res = getReservationForCell(room.roomNo, d);
                        const isCheckIn = res && res.checkindate === format(d, "yyyy-MM-dd");

                        return (
                          <Box key={d.toISOString()} width={COL_WIDTH} height={ROW_HEIGHT} sx={{
                            borderRight: "1px solid #e2e8f0",
                            borderBottom: "1px solid #e2e8f0",
                            position: "relative",
                            cursor: res ? "default" : "pointer",
                            transition: "background-color 0.15s",
                            "&:hover": { bgcolor: res ? "transparent" : "#f8fafc" }
                          }}
                            onContextMenu={(e) => !res && handleCellRightClick(e, rt, room, d)}
                            onClick={() => {
                              if (res) return;
                              setSelected({ roomType: rt, roomNumber: room.roomNo, roomInfoId: room.id });
                              getRoomTypeData({ roomType: rt, roomNumber: room.roomNo, roomInfoId: room.id });
                              setcheckindate(format(d, "yyyy-MM-dd"));
                              setcheckoutdate(format(addDays(d, 1), "yyyy-MM-dd"));
                              setOpen(true);
                            }}
                          >
                            <AnimatePresence>
                              {isCheckIn && (() => {
                                const isVisible = () => {
                                  if (activeFilter === "All") return true;
                                  if (res.status === "Blocked") return activeFilter === "Blocked";
                                  const normSource = (res.bookingsource || "").toLowerCase().trim();
                                  switch (activeFilter) {
                                    case "Direct": return normSource.includes("website") || normSource.includes("direct");
                                    case "OTA": return normSource.includes("booking") || normSource.includes("ota") || normSource.includes("expedia");
                                    case "MMT": return normSource.includes("mmt") || normSource.includes("makemytrip") || normSource.includes("makey my trip") || normSource.includes("goibibo") || normSource.includes("agoda") || normSource.includes("agpda");
                                    case "Walk-in": return normSource.includes("walk");
                                    case "Call": return normSource.includes("call") || normSource.includes("phone");
                                    default: return true;
                                  }
                                };
                                const cellOpacity = isVisible() ? 1 : 0.15;

                                if (res.status === "Blocked") {
                                  return (
                                    <motion.div
                                      initial={{ y: 6, opacity: 0, scale: 0.96 }}
                                      animate={{ y: 0, opacity: cellOpacity, scale: 1 }}
                                      exit={{ opacity: 0, scale: 0.92 }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        Swal.fire({
                                          title: 'Remove Block?',
                                          text: "Do you want to unblock this room?",
                                          icon: 'warning',
                                          showCancelButton: true,
                                          confirmButtonColor: '#3085d6',
                                          cancelButtonColor: '#d33',
                                          confirmButtonText: 'Yes, Unblock'
                                        }).then((result) => {
                                          if (result.isConfirmed) unblockReservation(res);
                                        });
                                      }}
                                      style={{
                                        position: "absolute", top: 2, left: 2, height: ROW_HEIGHT - 5,
                                        width: `calc(${differenceInDays(parseISO(res.checkoutdate), parseISO(res.checkindate))} * ${COL_WIDTH}px - 6px)`,
                                        backgroundColor: "rgba(239, 68, 68, 0.12)",
                                        color: "#b91c1c", borderLeft: "4px solid #ef4444", borderRadius: "6px",
                                        zIndex: isVisible() ? 10 : 1, padding: "4px 8px", display: "flex", flexDirection: "column",
                                        justifyContent: "center", overflow: "hidden", whiteSpace: "nowrap", cursor: "pointer"
                                      }}
                                    >
                                      <Box display="flex" alignItems="center" gap={0.5}>
                                        <Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: 'red', flexShrink: 0 }} />
                                        <Typography variant="caption" fontWeight={800} sx={{ lineHeight: 1.2 }}>
                                          BLOCKED
                                        </Typography>
                                      </Box>
                                      <Typography variant="caption" sx={{ fontSize: "10px", mt: 0.2, opacity: 0.8 }}>
                                        {res.note || "Maintenance"}
                                      </Typography>
                                    </motion.div>
                                  );
                                }

                                const theme = getBookingSourceStyles(res.bookingsource);
                                const normalizedSource = res.bookingsource?.toLowerCase() || "";
                                let logoSrc = "";
                                if (normalizedSource.includes("booking")) logoSrc = "/logos/booking.png";
                                else if (normalizedSource.includes("mmt") || normalizedSource.includes("makemytrip") || normalizedSource.includes("makey my trip")) logoSrc = "/logos/mmt.png";
                                else if (normalizedSource.includes("goibibo") || normalizedSource.includes("goibibio")) logoSrc = "/logos/goibibo.png";
                                else if (normalizedSource.includes("agoda") || normalizedSource.includes("agpda")) logoSrc = "/logos/agoda.png";

                                return (
                                  <motion.div
                                    initial={{ y: 6, opacity: 0, scale: 0.96 }}
                                    animate={{ y: 0, opacity: cellOpacity, scale: 1 }}
                                    exit={{ opacity: 0, scale: 0.92 }}
                                    transition={{ type: "spring", stiffness: 340, damping: 26 }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      navigate(`/reservation-details/${res.id}`);
                                    }}
                                    whileHover={{
                                      scale: isVisible() ? 1.015 : 1,
                                      boxShadow: isVisible() ? "0 6px 16px rgba(0, 0, 0, 0.1)" : "none",
                                      filter: isVisible() ? "brightness(0.97)" : "none"
                                    }}
                                    style={{
                                      position: "absolute",
                                      top: 2,
                                      left: 2,
                                      height: ROW_HEIGHT - 5,
                                      width: `calc(${differenceInDays(parseISO(res.checkoutdate), parseISO(res.checkindate))} * ${COL_WIDTH}px - 6px)`,
                                      backgroundColor: theme.bg,
                                      color: theme.text,
                                      borderLeft: `4px solid ${theme.border}`,
                                      borderRadius: "6px",
                                      zIndex: isVisible() ? 10 : 1,
                                      padding: "4px 8px",
                                      display: "flex",
                                      flexDirection: "column",
                                      justifyContent: "center",
                                      boxShadow: isVisible() ? "0 2px 6px rgba(0, 0, 0, 0.02)" : "none",
                                      overflow: "hidden",
                                      whiteSpace: "nowrap",
                                      cursor: "pointer"
                                    }}
                                  >
                                    <Typography
                                      variant="caption"
                                      fontWeight={800}
                                      sx={{ lineHeight: 1.2, textOverflow: "ellipsis", overflow: "hidden" }}
                                    >
                                      {res.customers?.custname?.toUpperCase()}
                                    </Typography>
                                    <Box display="flex" alignItems="center" justifyContent="space-between" mt={0.2} gap={1}>
                                      <Typography variant="caption" sx={{ fontSize: "10px", fontWeight: 600, opacity: 0.9 }}>
                                        ₹ {Number(res.totalamount).toLocaleString("en-IN")}
                                      </Typography>
                                      {logoSrc ? (
                                        <Box component="img" src={logoSrc} alt={res.bookingsource} sx={{ height: 11, objectFit: "contain", borderRadius: "2px" }} />
                                      ) : (
                                        <Box sx={{ fontSize: "8px", px: 0.6, py: 0.1, borderRadius: "3px", backgroundColor: theme.border, color: "#fff", fontWeight: 800, textTransform: "uppercase" }}>
                                          {res.bookingsource || "Direct"}
                                        </Box>
                                      )}
                                    </Box>
                                  </motion.div>
                                );
                              })()}
                            </AnimatePresence>
                          </Box>
                        );
                      })}
                    </Box>
                  ))}
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        </Card>
      </Box>

      {/* QUICK CONTEXT MENU */}
      <MuiMenu
        open={contextMenu !== null}
        onClose={() => setContextMenu(null)}
        anchorReference="anchorPosition"
        anchorPosition={
          contextMenu !== null ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined
        }
      >
        <MenuItem onClick={() => handleContextMenuSelect("Walk-in")}>1. Walk-in</MenuItem>
        <MenuItem onClick={() => handleContextMenuSelect("OTA (External)")}>2. OTA (External)</MenuItem>
        <MenuItem onClick={() => handleContextMenuSelect("On Call")}>3. On Call</MenuItem>
        <MenuItem onClick={() => handleContextMenuSelect("Reference")}>4. Reference</MenuItem>
        <MenuItem onClick={() => handleContextMenuSelect("B2B")}>5. B2B</MenuItem>
        <MenuItem onClick={() => handleContextMenuSelect("OTA (Automatic)")}>6. OTA (Automatic)</MenuItem>
        <Divider />
        <MenuItem onClick={() => handleContextMenuSelect("BlockRoom")} sx={{ color: 'error.main', fontWeight: 700 }}>7. Block Room</MenuItem>
      </MuiMenu>

      {/* BOOKING DIALOG */}
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="lg">
        <DialogTitle sx={{ fontWeight: 800, bgcolor: '#f8f9fa', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box display="flex" alignItems="center" gap={1.5}>
            <Typography variant="h6" fontWeight={800}>
              New {isBlocking ? "Block" : "Booking"} - Room {selected?.roomNumber || "102"}
            </Typography>
            <Box sx={{ bgcolor: '#e2e8f0', color: '#475569', fontSize: '11px', px: 1, py: 0.3, borderRadius: 1.5, fontWeight: 700 }}>
              {selected?.roomType?.roomTypeName || "Standard King Room"}
            </Box>
            <Box sx={{ bgcolor: '#dcfce7', color: '#15803d', fontSize: '11px', px: 1, py: 0.3, borderRadius: 1.5, fontWeight: 700 }}>
              Clean
            </Box>
          </Box>
          <FormControlLabel
            control={<Switch checked={isBlocking} onChange={(e) => setIsBlocking(e.target.checked)} color="error" />}
            label={<Typography fontWeight={600} color={isBlocking ? "error" : "text.secondary"}>Block Room</Typography>}
          />
        </DialogTitle>

        <DialogContent sx={{ mt: 2, p: 3, position: 'relative' }}>
          {isLoading && (
            <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, bgcolor: 'rgba(255,255,255,0.7)', zIndex: 99, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <CircularProgress size={50} />
            </Box>
          )}

          {!isBlocking && (
            <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 4 }}>
              {steps.map(label => <Step key={label}><StepLabel>{label}</StepLabel></Step>)}
            </Stepper>
          )}

          {/* STEP 0: ROOM DETAILS */}
          {activeStep === 0 && (
            <Box>
              <div className="row mb-3">
                <div className="col-12 col-md-4 mb-3">
                  <Card variant="outlined" sx={{ borderRadius: 2 }}>
                    <CardContent>
                      <Stack spacing={2}>
                        <TextField
                          label="Check-In"
                          type="date"
                          size="small"
                          InputLabelProps={{ shrink: true }}
                          value={checkindate}
                          onChange={(e) => { setcheckindate(e.target.value); handleDateChange(e.target.value, checkoutdate); }}
                          sx={getFieldStyle(checkindate, true)}
                        />
                        <TextField
                          label="Check-Out"
                          type="date"
                          size="small"
                          InputLabelProps={{ shrink: true }}
                          value={checkoutdate}
                          onChange={(e) => { setcheckoutdate(e.target.value); handleDateChange(checkindate, e.target.value); }}
                          sx={getFieldStyle(checkoutdate, true)}
                        />
                        <TextField
                          label="No of Days"
                          size="small"
                          value={noofdays}
                          InputProps={{ readOnly: true }}
                          sx={getFieldStyle(noofdays)}
                        />
                      </Stack>
                    </CardContent>
                  </Card>
                </div>

                {!isBlocking && (
                  <div className="col-12 col-md-4 mb-3">
                    <Card variant="outlined" sx={{ borderRadius: 2 }}>
                      <CardContent>
                        <Stack spacing={2}>
                          <TextField
                            label="Check-In Time"
                            size="small"
                            value={checkintime}
                            onChange={e => setcheckintime(e.target.value)}
                            sx={getFieldStyle(checkintime)}
                          />
                          <TextField
                            label="Check-Out Time"
                            size="small"
                            value={checkouttime}
                            onChange={e => setcheckouttime(e.target.value)}
                            sx={getFieldStyle(checkouttime)}
                          />
                        </Stack>
                      </CardContent>
                    </Card>
                  </div>
                )}

                <div className={isBlocking ? "col-12 col-md-8 mb-3" : "col-12 col-md-4 mb-3"}>
                  <Card variant="outlined" sx={{ borderRadius: 2, height: '100%' }}>
                    <CardContent>
                      <Stack spacing={1.5}>
                        {!isBlocking && [{ label: "Adults", val: adults, setter: setadults, min: 1 }, { label: "Children", val: childs, setter: setchilds, min: 0 }].map((item) => (
                          <Box key={item.label} display="flex" justifyContent="space-between" alignItems="center">
                            <Typography variant="body2" fontWeight={600}>{item.label}</Typography>
                            <Box display="flex" alignItems="center" gap={1}>
                              <IconButton size="small" onClick={() => item.setter(Math.max(item.min, item.val - 1))}><Remove fontSize="small" /></IconButton>
                              <Typography fontWeight={700} width={20} textAlign="center">{item.val}</Typography>
                              <IconButton size="small" onClick={() => item.setter(item.val + 1)}><Add fontSize="small" /></IconButton>
                            </Box>
                          </Box>
                        ))}
                        {!isBlocking && <Divider />}
                        {isBlocking && (
                          <Box mb={2}>
                            <TextField
                              label="Reason for blocking"
                              size="small"
                              fullWidth
                              value={note}
                              onChange={e => setnote(cleanAlphanumeric(e.target.value))}
                              placeholder="e.g. Deep Cleaning / Maintenance"
                              sx={getFieldStyle(note, true)}
                            />
                          </Box>
                        )}
                        <Box display="flex" justifyContent="space-between">
                          <Typography variant="body2" fontWeight={600}>Total Rooms {isBlocking ? "Blocked" : "Added"}</Typography>
                          <Typography fontWeight={700}>{noofrooms}</Typography>
                        </Box>
                      </Stack>
                    </CardContent>
                  </Card>
                </div>
              </div>

              <Card variant="outlined" sx={{ borderRadius: 2 }}>
                <CardContent>
                  <div className="row align-items-center">
                    <div className="col-12 col-md-3 mb-3">
                      <TextField
                        select
                        label="Room Type"
                        size="small"
                        fullWidth
                        value={rtypeid}
                        onChange={(e) => handleroomtypeChange(e.target.value)}
                        sx={getFieldStyle(rtypeid, true)}
                      >
                        {roomTypes.map(item => <MenuItem key={item.id} value={item.id}>{item.roomTypeName}</MenuItem>)}
                      </TextField>
                    </div>
                    <div className="col-12 col-md-2 mb-3">
                      <TextField
                        select
                        label="Room No"
                        size="small"
                        fullWidth
                        value={roomid}
                        onChange={(e) => setroomid(e.target.value)}
                        sx={getFieldStyle(roomid, true)}
                      >
                        {availableRooms.length === 0 && <MenuItem disabled value="">No rooms available</MenuItem>}
                        {availableRooms.map(item => <MenuItem key={item.id} value={item.id}>{item.data.roomNo}</MenuItem>)}
                      </TextField>
                    </div>

                    {!isBlocking && (
                      <>
                        <div className="col-12 col-md-2 mb-3">
                          <TextField
                            select
                            label="Plan"
                            size="small"
                            fullWidth
                            value={planid}
                            onChange={(e) => handleplanChange(e.target.value)}
                            sx={getFieldStyle(planid, true)}
                          >
                            {plans.map(item => <MenuItem key={item.id} value={item.id}>{item.data.planName}</MenuItem>)}
                          </TextField>
                        </div>
                        <div className="col-12 col-md-2 mb-3">
                          <TextField
                            label="Amount"
                            size="small"
                            fullWidth
                            value={amount}
                            onChange={e => { setamount(e.target.value); setroomrate(e.target.value); }}
                            sx={getFieldStyle(amount, true)}
                            InputProps={{
                              readOnly: !isAmountUnlocked,
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton size="small" onClick={toggleAmountLock}>
                                    {isAmountUnlocked ? <LockOpenOutlined fontSize="small" color="warning" /> : <LockOutlined fontSize="small" />}
                                  </IconButton>
                                </InputAdornment>
                              )
                            }}
                          />
                        </div>
                        <div className="col-12 col-md-2 mb-3">
                          <TextField
                            label="Discount (%)"
                            type="number"
                            size="small"
                            fullWidth
                            value={discount}
                            onChange={e => {
                              let val = Number(e.target.value);
                              if (val > discountupto) { setDiscountError(`Max ${discountupto}%`); setdiscount(discountupto); }
                              else { setDiscountError(""); setdiscount(val); setroomrate((amount - (amount * val) / 100).toFixed(2)); }
                            }}
                            error={!!discountError}
                            helperText={discountError}
                            sx={getFieldStyle(discount, false, !!discountError)}
                          />
                        </div>
                      </>
                    )}

                    <div className="col-8 col-md-1 mb-3">
                      <Button
                        fullWidth
                        variant="contained"
                        sx={{
                          height: 40,
                          animation: isRoomReadyToAdd ? "pumpingGlow 1.2s infinite ease-in-out" : "none",
                          "@keyframes pumpingGlow": {
                            "0%": { transform: "scale(1)", boxShadow: "0 0 0 0 rgba(2, 132, 199, 0.7)" },
                            "50%": { transform: "scale(1.08)", boxShadow: "0 0 0 8px rgba(2, 132, 199, 0)" },
                            "100%": { transform: "scale(1)", boxShadow: "0 0 0 0 rgba(2, 132, 199, 0)" }
                          }
                        }}
                        onClick={handleRoomArray}
                      >
                        <Add />
                      </Button>
                    </div>
                  </div>

                  {bookingrooms.map((item, i) => (
                    <div className="row align-items-center mt-2 border-bottom pb-2" key={i}>
                      <div className="col-12 col-md-2"><Typography variant="body2">{item.roomtypename}</Typography></div>
                      <div className="col-12 col-md-2"><Typography variant="body2" fontWeight={700}>RM: {item.roomno}</Typography></div>
                      {!isBlocking && (
                        <>
                          <div className="col-12 col-md-2"><Typography variant="body2">{item.planname}</Typography></div>
                          <div className="col-12 col-md-2"><Typography variant="body2">₹ {item.amount}</Typography></div>
                          <div className="col-12 col-md-1"><Typography variant="body2">{item.discount}%</Typography></div>
                          <div className="col-12 col-md-2"><Typography variant="body2" color="primary" fontWeight={700}>₹ {item.roomrate}</Typography></div>
                        </>
                      )}
                      <div className="col-12 col-md-1"><IconButton color="error" size="small" onClick={() => removeItem(item)}><Delete fontSize="small" /></IconButton></div>
                    </div>
                  ))}
                </CardContent>
              </Card>
            </Box>
          )}

          {/* STEP 1: CUSTOMER DETAILS (Clean 4-Card Dashboard Layout) */}
          {!isBlocking && activeStep === 1 && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
              <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 2.5 }}>

                {/* CARD 1: PRIMARY GUEST */}
                <Card variant="outlined" sx={{ borderRadius: 3, p: 2.5, bgcolor: '#ffffff', boxShadow: '0 2px 10px rgba(0,0,0,0.03)' }}>
                  <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                    <Box display="flex" alignItems="center" gap={1}>
                      <Typography variant="subtitle1" fontWeight={700} color="#1e293b">
                        Primary Guest
                      </Typography>
                      <Box sx={{ bgcolor: '#e0e7ff', color: '#4338ca', fontSize: '11px', px: 1, py: 0.3, borderRadius: 1.5, fontWeight: 700 }}>
                        VIP Member
                      </Box>
                    </Box>
                    <Button size="small" variant="contained" sx={{ bgcolor: '#312e81', textTransform: 'none', borderRadius: 2, fontSize: '11px', px: 1.5 }}>
                      Search returning guests
                    </Button>
                  </Box>

                  <Stack spacing={2}>
                    <TextField
                      size="small"
                      fullWidth
                      label="Guest Name *"
                      placeholder="e.g. Jay Shah"
                      value={custname}
                      onChange={(e) => setcustname(cleanName(e.target.value))}
                      sx={getFieldStyle(custname, true)}
                    />

                    <Box display="flex" gap={1.5}>
                      <TextField
                        size="small"
                        fullWidth
                        label="Mobile *"
                        placeholder="10-digit number"
                        value={mobile}
                        onChange={(e) => setmobile(cleanDigits(e.target.value).slice(0, 10))}
                        error={mobile.length > 0 && mobile.length < 10}
                        helperText={mobile.length > 0 && mobile.length < 10 ? "10 digits required" : ""}
                        sx={getFieldStyle(mobile, true, mobile.length > 0 && mobile.length < 10)}
                      />
                      <TextField
                        size="small"
                        fullWidth
                        label="Email *"
                        placeholder="guest@example.com"
                        type="email"
                        value={email}
                        onChange={(e) => setemail(e.target.value.replace(/[^a-zA-Z0-9@._-]/g, ""))}
                        sx={getFieldStyle(email, true)}
                      />
                    </Box>

                    {/* ID Details Row */}
                    <Box display="flex" gap={1.5} alignItems="center">
                      <TextField
                        select
                        size="small"
                        sx={{ width: '45%', ...getFieldStyle(documenttype, true) }}
                        label="ID Type *"
                        value={documenttype}
                        onChange={(e) => {
                          setdocumenttype(e.target.value);
                          setidno('');
                          setError('');
                        }}
                      >
                        {DOCUMENT_TYPES.map((doc) => (
                          <MenuItem key={doc.value} value={doc.value}>{doc.label}</MenuItem>
                        ))}
                      </TextField>

                      <TextField
                        size="small"
                        sx={{ flex: 1, ...getFieldStyle(idno, true, !!error) }}
                        label="ID Number *"
                        placeholder={VALIDATION_RULES[documenttype]?.placeholder || "Select ID Type"}
                        value={idno}
                        disabled={!documenttype}
                        error={!!error}
                        helperText={error}
                        onChange={(e) => {
                          const rule = VALIDATION_RULES[documenttype];
                          const sanitized = rule ? rule.clean(e.target.value) : cleanAlphanumeric(e.target.value);
                          setidno(sanitized);
                          if (rule) {
                            setError(rule.pattern.test(sanitized) ? '' : rule.message);
                          }
                        }}
                      />

                      <Button
                        variant="outlined"
                        size="small"
                        startIcon={<UploadFile />}
                        onClick={() => {
                          setActiveDocUploadKey('idFront');
                          if (fileInputRef.current) fileInputRef.current.click();
                        }}
                        sx={{ textTransform: 'none', height: 40, whiteSpace: 'nowrap', borderRadius: 2 }}
                      >
                        Upload
                      </Button>
                    </Box>

                    {/* Purpose of Visit */}
                    <Box>
                      <Typography variant="caption" fontWeight={600} color="text.secondary" mb={0.5} display="block">
                        Visit Purpose
                      </Typography>
                      <Stack direction="row" spacing={1}>
                        {["Business", "Vacation", "Personal"].map((purpose) => (
                          <Button
                            key={purpose}
                            size="small"
                            variant={visitpurpose === purpose ? "contained" : "outlined"}
                            onClick={() => setvisitpurpose(purpose)}
                            sx={{
                              borderRadius: 3,
                              fontSize: '11px',
                              textTransform: 'none',
                              py: 0.3,
                              px: 1.5,
                              bgcolor: visitpurpose === purpose ? '#312e81' : 'transparent',
                              borderColor: visitpurpose === purpose ? '#312e81' : '#cbd5e1',
                              color: visitpurpose === purpose ? '#fff' : '#64748b'
                            }}
                          >
                            {purpose}
                          </Button>
                        ))}
                      </Stack>
                    </Box>
                  </Stack>
                </Card>

                {/* CARD 2: STAY CONTEXT */}
                <Card variant="outlined" sx={{ borderRadius: 3, p: 2.5, bgcolor: '#ffffff', boxShadow: '0 2px 10px rgba(0,0,0,0.03)' }}>
                  <Typography variant="subtitle1" fontWeight={700} color="#1e293b" mb={2}>
                    Stay Context
                  </Typography>

                  <Stack spacing={2}>
                    <Box display="flex" gap={1.5}>
                      <TextField
                        size="small"
                        fullWidth
                        label="Stay Dates"
                        value={`${checkindate} to ${checkoutdate} (${noofdays} Nights)`}
                        InputProps={{ readOnly: true }}
                        sx={getFieldStyle(noofdays)}
                      />
                      <TextField
                        select
                        size="small"
                        fullWidth
                        label="Booking Source"
                        value={bookingsource}
                        onChange={(e) => setbookingsource(e.target.value)}
                        sx={getFieldStyle(bookingsource)}
                      >
                        {bookingtypes.length > 0 ? (
                          bookingtypes.map(item => (
                            <MenuItem key={item.id} value={item.data.bookingtype}>{item.data.bookingtype}</MenuItem>
                          ))
                        ) : (
                          ["Walk-in", "OTA (External)", "On Call", "Reference", "B2B", "OTA (Automatic)"].map(type => (
                            <MenuItem key={type} value={type}>{type}</MenuItem>
                          ))
                        )}
                      </TextField>
                    </Box>

                    <Box display="flex" gap={1.5}>
                      <TextField
                        size="small"
                        fullWidth
                        label="City *"
                        value={city}
                        onChange={(e) => setcity(cleanCity(e.target.value))}
                        sx={getFieldStyle(city, true)}
                      />
                      <TextField
                        select
                        size="small"
                        fullWidth
                        label="State"
                        value={state}
                        onChange={(e) => setstate(e.target.value)}
                        sx={getFieldStyle(state, true)}
                      >
                        <MenuItem value="Maharashtra">Maharashtra</MenuItem>
                        <MenuItem value="Goa">Goa</MenuItem>
                        <MenuItem value="Gujarat">Gujarat</MenuItem>
                        <MenuItem value="Karnataka">Karnataka</MenuItem>
                        <MenuItem value="Delhi">Delhi</MenuItem>
                        <MenuItem value="Other">Other</MenuItem>
                      </TextField>
                      <TextField
                        size="small"
                        fullWidth
                        label="Company"
                        value={companydetails}
                        onChange={(e) => setcompanydetails(cleanAlphanumeric(e.target.value))}
                        sx={getFieldStyle(companydetails)}
                      />
                    </Box>

                    {/* GST Details */}
                    <Box>
                      <Typography variant="caption" fontWeight={600} color="text.secondary" mb={1} display="block">
                        GST Information (Optional)
                      </Typography>
                      <Box display="flex" gap={1.5}>
                        <TextField
                          size="small"
                          fullWidth
                          label="GST Name"
                          value={gstname}
                          onChange={(e) => setgstname(cleanAlphanumeric(e.target.value))}
                          sx={getFieldStyle(gstname)}
                        />
                        <TextField
                          size="small"
                          fullWidth
                          label="GST Number"
                          placeholder="15-digit GSTIN"
                          value={gstno}
                          onChange={(e) => setgstno(cleanGST(e.target.value).slice(0, 15))}
                          sx={getFieldStyle(gstno)}
                        />
                      </Box>
                    </Box>

                    <TextField
                      size="small"
                      fullWidth
                      label="Street Address *"
                      value={address}
                      onChange={(e) => setaddress(e.target.value.replace(/[^a-zA-Z0-9\s,.-]/g, ""))}
                      sx={getFieldStyle(address, true)}
                    />
                  </Stack>
                </Card>
              </Box>

              {/* BOTTOM ROW: ADDITIONAL GUESTS & BOOKING SUMMARY */}
              <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 2.5 }}>

                {/* CARD 3: ADDITIONAL GUESTS */}
                <Card variant="outlined" sx={{ borderRadius: 3, p: 2.5, bgcolor: '#ffffff', boxShadow: '0 2px 10px rgba(0,0,0,0.03)' }}>
                  <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <Typography variant="subtitle1" fontWeight={700} color="#1e293b">
                      Additional Guests ({adultsList.length})
                    </Typography>
                    <Button
                      size="small"
                      variant="contained"
                      sx={{ bgcolor: '#312e81', textTransform: 'none', borderRadius: 2, fontSize: '11px' }}
                      onClick={() => setAdultsList([...adultsList, { name: '', mobile: '', docType: 'aadhaar', idNo: '', error: '' }])}
                    >
                      + Add Another Guest
                    </Button>
                  </Box>

                  <Stack spacing={1.5} sx={{ maxHeight: 220, overflowY: 'auto', pr: 0.5 }}>
                    {adultsList.length === 0 && (
                      <Typography variant="body2" color="text.secondary" textAlign="center" py={3}>
                        No additional guests added.
                      </Typography>
                    )}

                    {adultsList.map((adult, index) => (
                      <Box key={index} sx={{ border: '1px solid #e2e8f0', borderRadius: 2, p: 1.5, bgcolor: '#f8fafc' }}>
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                          <Typography variant="caption" fontWeight={700}>Guest #{index + 1}</Typography>
                          <IconButton size="small" color="error" onClick={() => setAdultsList(adultsList.filter((_, i) => i !== index))}>
                            <Delete fontSize="small" />
                          </IconButton>
                        </Box>

                        <Box display="flex" gap={1} mb={1}>
                          <TextField
                            size="small"
                            fullWidth
                            label="Name"
                            value={adult.name}
                            onChange={(e) => {
                              let arr = [...adultsList];
                              arr[index].name = cleanName(e.target.value);
                              setAdultsList(arr);
                            }}
                            sx={getFieldStyle(adult.name)}
                          />
                          <TextField
                            size="small"
                            fullWidth
                            label="Mobile"
                            value={adult.mobile}
                            onChange={(e) => {
                              let arr = [...adultsList];
                              arr[index].mobile = cleanDigits(e.target.value).slice(0, 10);
                              setAdultsList(arr);
                            }}
                            sx={getFieldStyle(adult.mobile)}
                          />
                        </Box>

                        <Box display="flex" gap={1}>
                          <TextField
                            select
                            size="small"
                            sx={{ width: '45%', ...getFieldStyle(adult.docType) }}
                            label="ID Type"
                            value={adult.docType || 'aadhaar'}
                            onChange={(e) => {
                              let arr = [...adultsList];
                              arr[index].docType = e.target.value;
                              arr[index].idNo = '';
                              arr[index].error = '';
                              setAdultsList(arr);
                            }}
                          >
                            {DOCUMENT_TYPES.map((doc) => (
                              <MenuItem key={doc.value} value={doc.value}>{doc.label}</MenuItem>
                            ))}
                          </TextField>

                          <TextField
                            size="small"
                            sx={{ flex: 1, ...getFieldStyle(adult.idNo, false, !!adult.error) }}
                            label="ID Number"
                            placeholder={VALIDATION_RULES[adult.docType]?.placeholder || "Enter ID"}
                            value={adult.idNo}
                            error={!!adult.error}
                            helperText={adult.error}
                            onChange={(e) => {
                              let arr = [...adultsList];
                              const docT = adult.docType || 'aadhaar';
                              const rule = VALIDATION_RULES[docT];
                              const sanitized = rule ? rule.clean(e.target.value) : cleanAlphanumeric(e.target.value);
                              arr[index].idNo = sanitized;
                              arr[index].error = rule && !rule.pattern.test(sanitized) ? rule.message : '';
                              setAdultsList(arr);
                            }}
                          />
                        </Box>
                      </Box>
                    ))}
                  </Stack>
                </Card>

                {/* CARD 4: BOOKING & BILLING SUMMARY */}
                <Card variant="outlined" sx={{ borderRadius: 3, p: 2.5, bgcolor: '#ffffff', boxShadow: '0 2px 10px rgba(0,0,0,0.03)' }}>
                  <Typography variant="subtitle1" fontWeight={700} color="#1e293b" mb={2}>
                    Booking Summary
                  </Typography>

                  <Box display="grid" gridTemplateColumns="1fr 1fr" gap={2}>
                    <Box>
                      <Typography variant="caption" fontWeight={700} color="text.secondary" mb={1} display="block">
                        Selected Rooms ({bookingrooms.length})
                      </Typography>
                      <Stack spacing={0.5}>
                        {bookingrooms.map((r, i) => (
                          <Box key={i} display="flex" justifyContent="space-between" bgcolor="#f8fafc" p={0.8} borderRadius={1.5}>
                            <Typography variant="caption" fontWeight={600}>RM {r.roomno} ({r.roomtypename})</Typography>
                            <Typography variant="caption" fontWeight={700} color="primary">₹{r.roomrate}</Typography>
                          </Box>
                        ))}
                      </Stack>
                    </Box>

                    <Box bgcolor="#f8fafc" p={1.5} borderRadius={2} display="flex" flexDirection="column" justifyContent="space-between">
                      <Typography variant="caption" fontWeight={700} color="text.secondary">Live Billing Summary</Typography>
                      <Box>
                        <Box display="flex" justifyContent="space-between" mb={0.5}>
                          <Typography variant="caption" color="text.secondary">Room Subtotal</Typography>
                          <Typography variant="caption" fontWeight={600}>₹{rooamount}</Typography>
                        </Box>
                        <Box display="flex" justifyContent="space-between" mb={0.5}>
                          <Typography variant="caption" color="text.secondary">Total Nights</Typography>
                          <Typography variant="caption" fontWeight={600}>x {noofdays}</Typography>
                        </Box>
                        <Divider sx={{ my: 0.5 }} />
                        <Box display="flex" justifyContent="space-between">
                          <Typography variant="subtitle2" fontWeight={800}>Total Amount</Typography>
                          <Typography variant="subtitle2" fontWeight={800} color="primary">₹{totalamount}</Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Card>
              </Box>
            </Box>
          )}

          {/* STEP 2: DOCUMENTS */}
          {!isBlocking && activeStep === 2 && (
            <div className="row">
              {[
                { label: 'Visitor Photo', key: 'visitor' },
                { label: 'ID Front', key: 'idFront' },
                { label: 'ID Back', key: 'idBack' },
                { label: 'Couple Photo', key: 'couple' }
              ].map(cam => (
                <div className="col-12 col-md-3 mb-3" key={cam.key}>
                  <Card variant="outlined" sx={{ borderRadius: 2, textAlign: 'center', p: 2 }}>
                    <Typography variant="subtitle2" mb={1}>{cam.label}</Typography>
                    {photos[cam.key] ? (
                      <Box>
                        <img src={photos[cam.key]} alt={cam.label} style={{ width: '100%', height: 110, objectFit: 'cover', borderRadius: 8, marginBottom: 8 }} />
                        <Stack direction="row" spacing={1} justifyContent="center">
                          <Button size="small" variant="outlined" onClick={() => setActiveCamera(cam.key)}>Retake</Button>
                          <Button size="small" variant="contained" onClick={() => uploadPhoto(cam.key)} disabled={uploadingState[cam.key]}>
                            {uploadingState[cam.key] ? <CircularProgress size={16} /> : "Upload"}
                          </Button>
                        </Stack>
                      </Box>
                    ) : (
                      <Box bgcolor="#f8fafc" height={130} display="flex" flexDirection="column" alignItems="center" justifyContent="center" borderRadius={2} border="1px dashed #cbd5e1" mb={1} gap={1}>
                        <Box display="flex" gap={1}>
                          <IconButton color="primary" onClick={() => setActiveCamera(cam.key)} title="Take Snapshot">
                            <CameraAlt />
                          </IconButton>
                          <IconButton
                            color="secondary"
                            onClick={() => {
                              setActiveDocUploadKey(cam.key);
                              if (fileInputRef.current) fileInputRef.current.click();
                            }}
                            title="Upload File"
                          >
                            <UploadFile />
                          </IconButton>
                        </Box>
                        <Typography variant="caption" color="text.secondary">Snapshot or Upload File</Typography>
                      </Box>
                    )}
                  </Card>
                </div>
              ))}
            </div>
          )}

          {/* STEP 3: PAYMENT & SUMMARY */}
          {!isBlocking && activeStep === 3 && (
            <Box>
              <div className="row mb-3">
                <div className="col-12 col-md-4 mb-3">
                  <Card variant="outlined" sx={{ borderRadius: 2, height: '100%' }}>
                    <CardHeader avatar={<Avatar src={photoUrls.visitorUrl || ""} />} title={<Typography fontWeight={700}>{custname}</Typography>} subheader={mobile} sx={{ pb: 0 }} />
                    <CardContent>
                      <InfoRow label="Address" value={`${address}, ${city}`} />
                      <InfoRow label="Check-In" value={`${checkindate} | ${checkintime}`} />
                      <InfoRow label="Check-Out" value={`${checkoutdate} | ${checkouttime}`} />
                      <InfoRow label="Rooms" value={bookingrooms.map(r => r.roomno).join(', ')} />
                    </CardContent>
                  </Card>
                </div>
                <div className="col-12 col-md-8 mb-3">
                  <Card variant="outlined" sx={{ borderRadius: 2, bgcolor: '#f8fafc' }}>
                    <CardContent>
                      <div className="row">
                        <div className="col-12 col-md-6 mb-3">
                          <Typography variant="subtitle2" mb={1} fontWeight={700}>Payment Mode 1</Typography>
                          <Stack spacing={1.5}>
                            <TextField select size="small" fullWidth label="Mode" value={paymode1} onChange={e => setpaymode1(e.target.value)} sx={getFieldStyle(paymode1)}>
                              {paymodes.map(m => <MenuItem key={m.id} value={m.id}>{m.data.paymode}</MenuItem>)}
                            </TextField>
                            <TextField type="number" size="small" fullWidth label="Amount" value={amount1} onChange={handleamount1} sx={getFieldStyle(amount1)} />
                            <TextField size="small" fullWidth label="Payment Note 1" value={paytime1} onChange={(e) => setpaytime1(cleanAlphanumeric(e.target.value))} sx={getFieldStyle(paytime1)} />
                          </Stack>
                        </div>

                        <div className="col-12 col-md-6 mb-3">
                          <Typography variant="subtitle2" mb={1} fontWeight={700}>Payment Mode 2 (Optional)</Typography>
                          <Stack spacing={1.5}>
                            <TextField select size="small" fullWidth label="Mode" value={paymode2} onChange={e => setpaymode2(e.target.value)} sx={getFieldStyle(paymode2)}>
                              {paymodes.map(m => <MenuItem key={m.id} value={m.id}>{m.data.paymode}</MenuItem>)}
                            </TextField>
                            <TextField type="number" size="small" fullWidth label="Amount" value={amount2} onChange={handleamount2} sx={getFieldStyle(amount2)} />
                            <TextField size="small" fullWidth label="Payment Note 2" value={paytime2} onChange={(e) => setpaytime2(cleanAlphanumeric(e.target.value))} sx={getFieldStyle(paytime2)} />
                          </Stack>
                        </div>

                        <div className="col-12">
                          <Divider sx={{ my: 2 }} />
                          <Box mb={2}>
                            <TextField size="small" fullWidth label="General Booking Note" value={note} onChange={(e) => setnote(cleanAlphanumeric(e.target.value))} sx={getFieldStyle(note)} />
                          </Box>

                          <Box display="flex" justifyContent="space-between" px={2}>
                            <Box textAlign="center">
                              <Typography variant="caption" color="text.secondary">Total</Typography>
                              <Typography variant="h6" fontWeight={800}>₹{totalamount}</Typography>
                            </Box>
                            <Box textAlign="center">
                              <Typography variant="caption" color="text.secondary">Advance</Typography>
                              <Typography variant="h6" color="success.main" fontWeight={800}>₹{advance}</Typography>
                            </Box>
                            <Box textAlign="center">
                              <Typography variant="caption" color="text.secondary">Remaining</Typography>
                              <Typography variant="h6" color="error.main" fontWeight={800}>₹{remaining}</Typography>
                            </Box>
                          </Box>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </div>
              </div>
            </Box>
          )}

          {/* BOTTOM ACTIONS */}
          <Box display="flex" justifyContent="space-between" alignItems="center" mt={3} pt={2} borderTop="1px solid #e2e8f0" flexWrap="wrap" gap={1}>
            <Button color="error" onClick={() => setOpen(false)}>Cancel</Button>

            {!isBlocking && activeStep === steps.length - 1 && (
              <Box display="flex" gap={1}>
                <Button size="small" variant="outlined" color="warning" onClick={() => pushToPipeline('On Hold')}>
                  Hold
                </Button>
                <Button size="small" variant="outlined" color="info" onClick={() => pushToPipeline('Enquiry')}>
                  Enquiry
                </Button>
                <Button size="small" variant="outlined" color="secondary" onClick={() => pushToPipeline('Unassigned')}>
                  Unassigned
                </Button>
              </Box>
            )}

            <Box display="flex" gap={2}>
              {!isBlocking && <Button disabled={activeStep === 0} onClick={handleBack} startIcon={<ArrowBackIosNew fontSize="small" />}>Back</Button>}
              {isBlocking ? (
                <Button variant="contained" color="error" onClick={blockReservation} sx={{ px: 4, fontWeight: 700 }}>Confirm Block</Button>
              ) : activeStep === steps.length - 1 ? (
                <Button variant="contained" color="success" onClick={checkoutReservation} sx={{ px: 4, fontWeight: 700 }}>Confirm Booking</Button>
              ) : (
                <Button variant="contained" color="primary" onClick={handleNext} endIcon={<ArrowForwardIos fontSize="small" />} sx={{ px: 4, fontWeight: 700 }}>Next</Button>
              )}
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      {/* WEBCAM DIALOG */}
      <Dialog open={Boolean(activeCamera)} onClose={() => setActiveCamera(null)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ fontWeight: 700 }}>Capture Image</DialogTitle>
        <DialogContent sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
          {activeCamera && <Webcam audio={false} ref={webcamRef} screenshotFormat="image/jpeg" width="100%" style={{ borderRadius: 8 }} />}
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setActiveCamera(null)} color="inherit">Cancel</Button>
          <Button variant="contained" onClick={handleCapture} startIcon={<CameraAlt />}>Capture Now</Button>
        </DialogActions>
      </Dialog>

    </Box>
  );
}